import React, { FC, useState } from "react"

import { KSpan } from "kahuna-base-react-components"
import { AssetRegistryPages } from "../../../../actions/types"
import { lang } from "../../../../constants/languages"

type NavigationFlowProps = {
  selectedTab: number
  setSelectedTab: (value: number) => void
  navigationZIndex: number
}

interface NavigationOption {
  value: number
  label: string
}

const navigationOptions: NavigationOption[] = [
  { value: AssetRegistryPages.GENERAL_INFORMATION, label: lang.catalog.asset_registry.navigation_steps.general_information },
  { value: AssetRegistryPages.TRACKS_AND_ASSETS, label:  lang.catalog.asset_registry.navigation_steps.tracks_and_assets },
  { value: AssetRegistryPages.TERRITORY_AND_PLATFORM_RIGHTS, label: lang.catalog.asset_registry.navigation_steps.territory_and_platform_rights },
  { value: AssetRegistryPages.EDITORIAL_PITCHING, label:  lang.catalog.asset_registry.navigation_steps.editorial_pitching },
  { value: AssetRegistryPages.SUMMARY, label:  lang.catalog.asset_registry.navigation_steps.summary }
]

const NavigationFlow: FC<NavigationFlowProps> = (props) => {
  const renderNavigationOptions = () => {
    const len = navigationOptions.length
    const width = `calc((70vw - ${len * 8}px) / (${len - 1}))`
    return (
      <div
        className={` flex flex-row justify-between`}
        style={{
          width: "100%", zIndex: props.navigationZIndex
        }}
      >
        {navigationOptions.map((option, index) => {
          return (
            <div
              key={`navigation-${option.value}`}
              className={"flex cursor-pointer"}
              onClick={() => props.setSelectedTab(option.value)}
            >
              <div
                className="w-2 h-2 rounded-full relative"
                style={{
                  backgroundColor: props.selectedTab >= option.value ? "#111" : "#F0F0F0"
                }}
              >
                <div
                  className="absolute text-nowrap"
                  style={{
                    left: "50%",
                    top: "14px",
                    transform: "translateX(-50%)"
                  }}
                >
                  <KSpan
                    text={option.label}
                    fontWeight={props.selectedTab >= option.value ? 500 : 400}
                    color={`${props.selectedTab >= option.value ? "#111" : "#737373"}`}
                  />
                </div>
                {index < 4 && (
                  <div
                    className={`h-0.5 absolute top-[3px] left-2 `}
                    style={{
                      width,
                      backgroundColor: props.selectedTab >= option.value + 1 ? "#111" : "#F0F0F0"
                    }}
                  />
                )}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div style={{ height: "100%", width: "100%" }} className={"flex justify-center pt-4"}>
      <div className={`w-[70vw] flex flex-row justify-center  `}>{renderNavigationOptions()}</div>
    </div>
  )
}

export default NavigationFlow
